import { Head, Link, router } from '@inertiajs/react'
import { TaxTypeType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft, Edit, Trash2} from "lucide-react";

interface ShowProps {
  tax_type: TaxTypeType
  can_edit: boolean
  can_destroy?: boolean
}

export default function Show({ tax_type, can_edit, can_destroy = false }: ShowProps) {

  const handleDestroy = () => {
    if (!window.confirm(`Supprimer le type de taxe "${tax_type.name}" ?`)) return

    router.delete(`/admin/tax_types/${tax_type.id}`)
  }

  return (
    <>
      <Head title={`Type de taxe #${tax_type.id}`} />

      <div className="p-8">
        <div className="mb-6">
          <Link href="/admin/tax_types">
            <Button variant="ghost" size="sm" className="mb-4 gap-2">
              <ArrowLeft className="h-4 w-4" />
              Retour
            </Button>
          </Link>

          <div className="flex items-start justify-between">
            <div>
              <div className="flex items-center gap-3">
                <h2 className="text-3xl font-bold text-foreground">{tax_type.name}</h2>
                <span className="rounded-full bg-primary/10 px-3 py-1 font-mono text-sm font-medium text-primary">
                {tax_type.code}
              </span>
                {tax_type.active && (
                    <span className="rounded-full bg-success/10 px-3 py-1 text-sm font-medium text-success">Actif</span>
                )}
              </div>
              <p className="mt-2 text-muted-foreground">{tax_type.description}</p>
            </div>
            <div className="flex items-center gap-2">
              {can_edit && (
                <Link href={`/admin/tax_types/${tax_type.id}/edit`}>
                  <Button className="gap-2">
                    <Edit className="h-4 w-4" />
                    Editer
                  </Button>
                </Link>
              )}
              {can_destroy && (
                <Button variant="outline" className="gap-2 text-destructive hover:text-destructive" onClick={handleDestroy}>
                  <Trash2 className="h-4 w-4" />
                  Supprimer
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
